import advertisement from "./advertisement";
import player from "./player";
import queue from "./queue";
import recommended from "./recommended";
import streams from "./streams";

export default {
  init: () => async (state, actions) => {
    actions.recommended.fetch();
    actions.queue.fetch();
    actions.streams.fetch().then(availableStreams => {
      const playerState = actions.player.get();
      const noTarget =
        Object.keys(playerState.target).length === 0 &&
        playerState.target.constructor === Object;
      // Determine play state
      let stream = null;
      let status = "stopped";
      const matches = window.location.hash.match(/#listen-live=(\d+)/);
      if (matches && matches[1]) {
        stream = availableStreams.find(s => s.id === parseInt(matches[1], 10));
        status = "playing";
      } else if (noTarget) {
        stream = availableStreams[0];
      }
      if (stream) {
        actions.player.set({
          status,
          target: {
            type: "stream",
            id: stream.id
          }
        });
      }
    });
    actions.advertisement.fetch();

    // Fetch streams every few minutes
    window.setInterval(actions.streams.fetch, 60 * 2 * 1000);
  },
  open: () => (state, actions) => {
    actions.activate();
    actions.queue.fetch();
    return { open: true };
  },
  close: () => ({ open: false }),
  activate: () => ({ activated: true }),
  setActiveTab: activeTab => ({ activeTab }),
  tick: () => ({ tick: Date.now() }),
  player,
  queue,
  recommended,
  streams,
  advertisement
};
